import "./gender.scss";
import "./genderResponsive.sass";
import {Link, NavLink, useHistory, useLocation} from "react-router-dom";
import { Hero } from "../../container/index";
import React, { useState } from "react";
import { News, Helm } from "../../components/index";
import { useEffect } from "react";
import { request } from "../../api/request";
import TomchiLogo from '../../assets/icons/TOMCHILOGO.png'
import { useDispatch } from "react-redux";
import { set_data } from "../../redux/action";
import { useSelector } from "react-redux";
import parser from "html-react-parser";
import QRcode from '../../assets/qrCode.png'
const Gender = () => {

    const dispatch = useDispatch();

    const event = useSelector((state) => state.data.data);
    const lang = useSelector((state) => state.data.lang);
    const news = useSelector(state => state.data.news)
    const [categories, setCategories] = useState([])

    const [active, setActive] = useState(0)

    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        request
            .get(`/content/all/event?sort=DESC&sortby=id&lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => dispatch(set_data(res.data)))
            .catch((err) => console.log(err));

        request
            .get(`/segment/all/event_category?lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => setCategories(res.data))
            .catch((err) => console.log(err));
    }, [lang]);
    return (
        <div className="events-page">
            {/*<Helm id={"37"}/>*/}

            <div className="hero-page">
                <Hero
                    id={"663"}
                    nameOne={
                        lang === "uz"
                            ? "Bosh sahifa"
                            : lang === "ru"
                                ? "Домой"
                                : lang === "en"
                                    ? "Home page"
                                    : ""
                    }
                    nameTwo={
                        lang === "uz"
                            ? "Gender konsepsiyasi"
                            : lang === "ru"
                                ? "Открытые данные"
                                : lang === "en"
                                    ? "Open data"
                                    : ""
                    }
                    linkOne={"/"}
                    linkTwo={"/gender-konsepsiya"}
                />
            </div>

            <div className="inner-pages container">
                <div className="col-one">
                    <div className="heading">
                        <h1 className="news-holder">Kategoriya</h1>
                    </div>
                    <div className="events-category">
                        <button
                            onClick={() => history.push('/gender-konsepsiya')}
                            className={currentPath === '/gender-konsepsiya' ? 'active' : ''}
                        >
                            Gender konsepsiyasi
                        </button>
                        <button
                            onClick={() => history.push('/gender-material')}
                            className={currentPath === '/gender-material' ? 'active' : ''}
                        >
                            Rasmiy taqdimot materiallari
                        </button>
                        <button
                            onClick={() => history.push('/gender-hikoya')}
                            className={currentPath === '/gender-hikoya' ? 'active' : ''}
                        >
                            Loyiha hikoyalari
                        </button>
                    </div>
                    <div className="tomchi">
                        <img src={QRcode} alt=""/>
                    </div>
                    <div className="tomchi-links">
                        <img src={TomchiLogo} alt=""/>
                        <h3 style={{
                            fontSize: '13px'
                        }} className='tomchi-title'>QR code skanerlang va Tomchi mobil ilovasini yuklab oling.</h3>
                    </div>
                </div>

                <div className="col-two">
                    <div className="heading">
                        <h1 className="news-holder">Suv xo'jaligida gender konsepsiyasi</h1>
                    </div>
                    <h2 style={{textAlign: "center", marginBottom: "10px"}}>Ўзбекистон сув хўжалигида гендер тенглигига
                        эришиш йўлида муҳим
                        қадам ташлади: 2025–2030 йилларга мўлжалланган Гендер концепцияси тақдим этилди</h2>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>Тошкент, 2025 йил 16 май
                        — Ўзбекистон Республикаси Сув хўжалиги вазирлиги 2025–2030 йилларга
                        мўлжалланган Сув хўжалиги соҳасида гендер концепциясини расман тақдим этди. Мазкур стратегик
                        ҳужжат сув ресурсларини бошқаришда эркаклар ва аёллар учун тенг ҳуқуқ ва имкониятларни
                        таъминлашга қаратилган.</p>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>Тақдимот Сув хўжалиги
                        вазирлиги ҳузуридаги Гендер кенгаши ва концепция ишлаб чиқиш бўйича ишчи гуруҳнинг
                        кенгайтирилган йиғилиши доирасида бўлиб ўтди. Тадбирда Олий Мажлис Сенати, Осиё тараққиёт банки,
                        Швейцариянинг ривожланиш ва ҳамкорлик агентлиги ҳамда миллий ва халқаро ҳамкор ташкилотлар
                        вакиллари иштирок этди.</p>
                    <h4 style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>Гендер концепциясининг
                        асосий мақсад ва вазифалари:</h4>
                    <ul style={{paddingLeft: "40px", marginBottom: "10px"}}>
                        <li style={{listStyleType: "disc"}}>Аёлларни сув ресурсларини бошқаришда фаол иштирокини
                            ошириш;
                        </li>
                        <li style={{listStyleType: "disc"}}>Гендер статистикаси ва аудитларини ривожлантириш;</li>
                        <li style={{listStyleType: "disc"}}>Гендер ҳиссиётли бюджетлаш тизимини жорий этиш;</li>
                        <li style={{listStyleType: "disc"}}>Сув хўжалигида таълим ва илм-фанга тенг кириш имкониятини
                            таъминлаш;
                        </li>
                        <li style={{listStyleType: "disc"}}>Ўзбекистоннинг халқаро рейтинглардаги ўрнини яхшилаш.</li>
                    </ul>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>Тақдимот доирасида
                        мутахассислар тақдимотлари, концепцияни тайёрлаш жараёни ҳақидаги видеоматериаллар, ҳудудлардан
                        фикр-мулоҳазалар ва 2027 йилгача амалга оширилиши режалаштирилган Ҳаракатлар режаси муҳокамаси
                        бўлиб ўтди.</p>
                    <h4 style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>Маълумот учун:</h4>
                    <h4 style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>Гендер концепцияси
                        қуйидаги асосий ҳужжатлар ва стратегияларга таянилган ҳолда ишлаб чиқилган:</h4>
                    <ul style={{paddingLeft: "40px", marginBottom: "10px"}}>
                        <li style={{listStyleType: "disc"}}>Ўзбекистон Республикаси Конституцияси;</li>
                        <li style={{listStyleType: "disc"}}>«Аёллар ва эркаклар учун тенг ҳуқуқ ва имкониятлар
                            кафолатлари тўғрисида»ги қонуни;
                        </li>
                        <li style={{listStyleType: "disc"}}>«Янги Ўзбекистон – 2026» ва «Ўзбекистон – 2030»
                            стратегиялари;
                        </li>
                        <li style={{listStyleType: "disc"}}>2030 йилгача бўлган барқарор ривожланиш миллий мақсадлари;
                        </li>
                        <li style={{listStyleType: "disc"}}>Шунингдек, халқаро тажриба ва Ўзбекистоннинг халқаро
                            мажбуриятлари.
                        </li>
                    </ul>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>Ҳужжат Сув хўжалиги
                        вазирлиги ваколатидаги бутун тизимни қамраб олади. Келгусида концепция доирасидаги
                        чора-тадбирларни ичимлик суви таъминоти ва бошқа соҳаларга ҳам татбиқ этиш
                        режалаштирилмоқда.</p>
                    <h4 style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>Концепциянинг асосий
                        йўналишлари:</h4>
                    <ul style={{paddingLeft: "40px", marginBottom: "10px"}}>
                        <li style={{listStyleType: "disc"}}>Аёлларни бошқарув жараёнларига жалб этишни
                            институционаллаштириш;
                        </li>
                        <li style={{listStyleType: "disc"}}>Гендер статистикасини тўплаш ва таҳлил қилиш;</li>
                        <li style={{listStyleType: "disc"}}>Гендер ҳиссиётли режалаш ва молиялашни жорий этиш;</li>
                        <li style={{listStyleType: "disc"}}>Аёлларни инновация, таълим, халқаро ҳамкорликка кенг жалб
                            қилиш;
                        </li>
                        <li style={{listStyleType: "disc"}}>Сув хўжалигида гендер маданиятини ва хабардорликни ошириш.
                        </li>
                    </ul>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>2030 йилгача кутилган
                        натижалар — раҳбарлик лавозимларидаги аёллар сонини ошириш, меҳнат шароитларини яхшилаш,
                        ходимлар хабардорлигини кучайтириш ва сув ресурслари соҳасида шаффофликни таъминлашдан
                        иборат.</p>
                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>Сув хўжалиги соҳасидаги
                        Гендер концепцияси — бу шунчаки ҳужжат эмас, балки адолатли, самарали ва барқарор келажак сари
                        қўйилган муҳим қадамдир. </p>
                    <p>
                        <br/>
                        <a
                            href="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/gender-konsepsiyasiuz.pdf"
                            target="_blank"
                            className="download-button"
                        >
                            Гендер консепсияси <i>(Юклаб олиш Узб)</i>
                        </a>

                        <a
                            href="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/gender-konsepsiyasien.pdf"
                            target="_blank"
                            className="download-button"
                        >
                            Гендер консепсияси <i>(Юклаб олиш Инг)</i>
                        </a>

                        <a
                            href="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/gender-konsepsiyasiru.pdf"
                            target="_blank"
                            className="download-button"
                            style={{display: "none"}}
                        >
                            Гендер консепсияси <i>(Юклаб олиш Рус)</i>
                        </a>
                    </p>

                </div>

                <div className="col-thr">
                    <h1 className="news-holder">
                        {lang === "uz"
                            ? "So’ngi yangiliklar"
                            : lang === "ru"
                                ? "последние новости"
                                : lang === "en"
                                    ? "Last news"
                                    : ""}
                    </h1>
                    {news && news.status === 1 ? (
                        news.data &&
                        news.data.map((el, index) => (
                            <News
                                date={el.created_on}
                                key={index}
                                title={el.title}
                                id={el.id}
                            />
                        ))
                    ) : (
                        <h1>Loading ...</h1>
                    )}
                </div>
            </div>

            <div className="margin"></div>
        </div>
    );
};

export default Gender;
